import React, { Component } from 'react';

import './Card.css';
import JavaScriptLogo from '../images/javascript.png';
import HTMLLogo from '../images/html.png';
import CSSLogo from '../images/css.png';
import herokuLogo from '../images/heroku.jpg';
import netlifyLogo from '../images/netlify.png';


class CardA extends Component {
    render() {
        return (
            <div className="Card">
                <h2>Anonymous Blogging Site</h2>
                <h4>HTML, JavaScript, CSS, Heroku and Netlify</h4>
                <p>PostIt's is a website where anonymous users can post and comment on other people's posts.</p>
                <div className="card-lang">
                    <img src={HTMLLogo} alt="HTM5" /> &nbsp;
                    <img src={JavaScriptLogo} alt="JavaScript" /> &nbsp;
                    <img src={CSSLogo} alt="CSS3" /> &nbsp;   
                    <img src={herokuLogo} alt="heroku" /> &nbsp; 
                    <img src={netlifyLogo} alt="Netlify" />
                </div><br />
                <div className="card-nav">
                    <div className="card-nav-left">
                        <a href="https://github.com/FopeA6/PostIts-Client" target="_blank" rel="noopener noreferrer">View Source Code</a>
                    </div>
                    <div className="card-nav-right">
                        <a href="https://postits.netlify.app/" target="_blank" rel="noopener noreferrer">View Project</a>
                    </div>
                </div>
            </div>
        );
    }
}

export default CardA
